import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {TransfersPage} from './components/TransfersPage';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';

export default function TransfersPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/all-transfers" component={TransfersPage}/>
      </Switch>
    </Suspense>
  );
}
